import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=f2736188&scoped=true&"
import script from "./WishList.vue?vue&type=script&lang=js&"
export * from "./WishList.vue?vue&type=script&lang=js&"
import style0 from "./WishList.vue?vue&type=style&index=0&id=f2736188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2736188",
  null
  
)

export default component.exports